import { useAuthState } from "../../context/AuthContext";
import { Col, Container, Row } from "react-bootstrap";
import NotificationDetailedList from "../../components/shared/notification/NotificationDetailedList";

const NotificationsPage = () => {

    const { user } = useAuthState();

    return (
        <Container fluid>
            <h3>{user.x_is_house_management ? "Benachrichtigungen" : "News"}</h3>
            <Row className="mt-3">
                <Col>
                    <NotificationDetailedList isHw={user.x_is_house_management} />
                </Col>
            </Row>
        </Container>
    )
}
export default NotificationsPage;